import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Box, TextField, Typography } from "@mui/material";
import React, { useState } from "react";
import { Controller, useForm } from "react-hook-form";
import { useNavigate } from "react-router-dom";
import { useRetrieveTeam, useRetrieveTeamPreferences, useRetrieveUserTeamPermissions, useUpdateTeamPreference, } from "../ApiProvider";
import { ErrorView } from "../nav/Error";
import { Forbidden } from "../nav/Forbidden";
import { Loading } from "../nav/Loading";
import { FormActions } from "../utils/FormActions";
import { useNumericParams } from "../utils/useNumericParams";
export const UpdateTeamPreference = () => {
    const { control, handleSubmit, formState: { errors }, } = useForm();
    const [loading, setLoading] = useState(false);
    const [error, setError] = useState(undefined);
    const navigate = useNavigate();
    const { id: teamId } = useNumericParams();
    const { data: userTeamPermissions, isLoading: userTeamPermissionsIsLoading, error: userTeamPermissionsError, } = useRetrieveUserTeamPermissions({ teamId });
    const { canModify = false } = userTeamPermissions || {};
    const { isLoading: isTeamLoading, error: teamError, data: team, } = useRetrieveTeam({ id: teamId, enabled: canModify });
    const { isLoading: teamPreferencesIsLoading, error: teamPreferencesError, data: teamPreference, } = useRetrieveTeamPreferences({ teamId, enabled: canModify });
    const mutation = useUpdateTeamPreference({
        teamId,
        onMutate: () => {
            setLoading(true);
        },
        onSuccess: () => {
            return navigate(`/teams/${team?.id}/`);
        },
        onError: (error) => setError(error),
    });
    if (userTeamPermissionsIsLoading) {
        return _jsx(Loading, {});
    }
    if (userTeamPermissionsError) {
        return _jsx(ErrorView, { error: userTeamPermissionsError });
    }
    if (!canModify) {
        return _jsx(Forbidden, {});
    }
    if (isTeamLoading || teamPreferencesIsLoading || loading) {
        return _jsx(Loading, {});
    }
    if (teamPreferencesError || error || teamError) {
        return _jsx(ErrorView, { error: teamPreferencesError });
    }
    const onSubmit = (data) => {
        mutation.mutate(data);
    };
    if (!team) {
        return (_jsx(Typography, { variant: "h6", children: "Could not retrieve team information!" }));
    }
    if (!teamPreference) {
        return (_jsxs(Typography, { variant: "h6", children: ["Could not retrieve ", team.name, " preferences!"] }));
    }
    return (_jsxs(React.Fragment, { children: [_jsx(Typography, { variant: "h6", children: _jsxs("strong", { children: ["Update ", team?.name, " Preferences"] }) }), _jsxs(Box, { component: "form", role: "form", onSubmit: handleSubmit(onSubmit), noValidate: true, sx: { mt: 1 }, children: [_jsx(Controller, { name: "teamAName", control: control, defaultValue: teamPreference.teamAName, rules: { required: "Team A Display Name is required" }, render: ({ field }) => (_jsx(TextField, { ...field, margin: "normal", required: true, fullWidth: true, id: "teamAName", label: "Team A Display Name", autoComplete: "teamAName", autoFocus: true, error: !!errors.teamAName, helperText: errors.teamAName ? errors.teamAName.message : "" })) }), _jsx(Controller, { name: "teamBName", control: control, defaultValue: teamPreference.teamBName, rules: { required: "Team B Display Name is required" }, render: ({ field }) => (_jsx(TextField, { ...field, margin: "normal", required: true, fullWidth: true, id: "teamBName", label: "Team B Display Name", autoComplete: "teamBName", error: !!errors.teamBName, helperText: errors.teamBName ? errors.teamBName.message : "" })) }), _jsx(FormActions, { submitLabel: "Update", isSubmitting: mutation.isLoading })] })] }));
};
